var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block",style:({
    height: _vm.Config.BLOCK_SIZE + _vm.Config.BLOCK_BORDER + 'px',
    width: _vm.Config.BLOCK_SIZE + _vm.Config.BLOCK_BORDER + 'px',
    borderWidth: _vm.Config.BLOCK_BORDER + 'px',
  })},[_c('div',{staticClass:"block-inside",style:({
      height: _vm.Config.BLOCK_SIZE - _vm.Config.BLOCK_BORDER + 1 + 'px',
      width: _vm.Config.BLOCK_SIZE - _vm.Config.BLOCK_BORDER + 1 + 'px',
      color: _vm.light ? '#666666' : '#a0a0a0',
      backgroundColor: _vm.light ? _vm.colors[_vm.colorId][0] : _vm.colors[_vm.colorId][1],
      boxShadow: _vm.light
        ? 'inset 0 0 5px rgba(255, 255, 255, 0.8)'
        : 'inset 0 0 5px rgba(0, 0, 0, 0.4)',
    })},[_vm._v(" "+_vm._s(_vm.ox)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }